import { ChangeDetectionStrategy, Component, computed, input, linkedSignal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AvAvatarSize } from '../../Types/av-avatar-size.type';

@Component({
  selector: 'av-avatar',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './av-avatar.component.html',
  styleUrl: './av-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvAvatarComponent {
  readonly name = input.required<string>();
  readonly photoUrl = input<string | null>(null);
  readonly size = input<AvAvatarSize>('md');

  private readonly _imageFailed = linkedSignal<string | null, boolean>({
    source: this.photoUrl,
    computation: () => false,
  });

  readonly initials = computed<string>(() => {
    const words = (this.name() ?? '').trim().split(/\s+/).filter(Boolean);

    if (words.length === 0) {
      return '';
    }

    const second = words.length > 1 ? words[1].charAt(0) : '';

    return (words[0].charAt(0) + second).toUpperCase();
  });

  readonly showImage = computed<boolean>(() => !!this.photoUrl() && !this._imageFailed());

  onImageError(): void {
    this._imageFailed.set(true);
  }
}
